// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9c09ed06","455":"4ab09753","977":"d2b064fd"}[chunkId] + ".chunk.js";
};